import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const validateShopperAgentStrategyGuidance = {
  name: "validateShopperAgentStrategyGuidance" as const,
  input: z.object({
    guidance: z.string(),
    /** The strategy's discount as currently selected in the editor; null uses the Playbook discount. */
    mongoDiscountId: zExt.objectId().nullable(),
  }),
  output: z.object({
    issues: z.array(
      z.object({
        start: z.number().int(),
        end: z.number().int(),
        message: z.string(),
        replacement: z.string().optional(),
        kind: z.string().optional(),
      }),
    ),
  }),
};
